import React from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import { Button } from 'reactstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AddImgButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <div>
        <FontAwesomeIcon icon={faPlus} />
        <span> </span>
        <IntlMessages id="property.add-img-button" />
      </div>
    </Button>
  );
};

export const AddInvokeApiButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <div>
        <FontAwesomeIcon icon={faPlus} />
        <span> </span>
        <IntlMessages id="property.add-invoke-api" />
      </div>
    </Button>
  );
};

export const AddLinkButton = ({ disabled }) => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      <IntlMessages id="property.add-link-button" />

    </Button>
  );
};

export const AddApiButton = ({ disabled }) => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      <IntlMessages id="property.add-api-button" />
    </Button>
  );
};

export const DisabledAddInvokeApiButton = () => {
  return (
    <Button
      disabled
      className="add-button"
      color="dark"
      outline
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faBan} />
      <span> </span>
      <IntlMessages id="property.add-invoke-api" />
    </Button>
  );
};

export const AddMessageButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      <IntlMessages id="property.add-message-button" />
    </Button>
  );
};

export const DisabledAddLinkButton = () => {
  return (
    <Button
      disabled
      className="add-button"
      color="dark"
      outline
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faBan} />
      <span> </span>
      <IntlMessages id="property.add-link-button" />
    </Button>
  );
};

export const DisabledAddImageButton = () => {
  return (
    <Button
      disabled
      className="add-button"
      color="dark"
      outline
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faBan} />
      <span> </span>
      <IntlMessages id="property.add-img-button" />
    </Button>
  );
};

export const DeleteButton = () => {
  return (
    <Button color="danger" size="xs" className="add-button">
      <IntlMessages id="property.delete" />
    </Button>
  );
};
export const AddHeroCardButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      <IntlMessages id="property.add-herocard-button" />
    </Button>
  );
};

export const AddVideoButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> Add Videos</span>
      {/* <IntlMessages id="property.add-message-button" /> */}
    </Button>
  );
};
export const DisabledAddVideoButton = () => {
  return (
    <Button
      disabled
      className="add-button"
      color="dark"
      outline
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faBan} />
      <span> Add Videos</span>
      {/* <IntlMessages id="property.add-img-button" /> */}
    </Button>
  );
};

// export const AddProductButton = () => {
//   return (
//     <Button
//       color="secondary"
//       className="add-button"
//       size="xs"
//       style={{ width: '100%' }}
//     >
//       <FontAwesomeIcon icon={faPlus} />
//       <span> Add Product</span>
//       {/* <IntlMessages id="property.add-message-button" /> */}
//     </Button>
//   );
// };
// export const AddRoomsButton = () => {
//   return (
//     <Button
//       color="secondary"
//       className="add-button"
//       size="xs"
//       style={{ width: '100%' }}
//     >
//       <FontAwesomeIcon icon={faPlus} />
//       <span> Add Rooms</span>
//       {/* <IntlMessages id="property.add-message-button" /> */}
//     </Button>
//   );
// };